import styled from "styled-components";

const HybridSelectWrapper = styled.div`
  position: relative;
`;

export default HybridSelectWrapper;
